import { Link } from '@on3/ui-lib/components/Link';
import clsx from 'clsx';

import styles from './BreadCrumb.module.scss';

type Crumb = {
  title: string;
  href?: string;
};

interface BreadCrumbProps {
  crumbs: Crumb[];
  color?: string | null;
  className?: string;
  title?: string;
}

export const BreadCrumb = ({
  className,
  color,
  crumbs,
  title,
}: BreadCrumbProps) => {
  return (
    <nav className={clsx(styles.block, className)}>
      {crumbs.map((crumb, index) => (
        <div className={styles.crumb} key={index}>
          <Link href={crumb.href} style={color ? { color } : {}}>
            {crumb.title}
          </Link>
        </div>
      ))}
      {title && <div className={styles.crumb}>{title}</div>}
    </nav>
  );
};
